import React from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import UsersInCellWidget from 'components/common/users/UsersInCellWidget';
import { getRoutesForPermissionCode } from 'helpers/permissionHelper';
const columns = [
  {
    accessor: 'evaUserId',
    Header: 'Eva User Id',
    Cell: rowData => {
      const { evaUserId } = rowData.row.original;
      return <div style={{alignItems:'center'}}><UsersInCellWidget showName usersText={evaUserId?.toString()} /></div>;
    }
  },
  {
    accessor: 'pageName',
    Header: 'Page Name',
    Cell: rowData => {
      const { pageName } = rowData.row.original;
      const routes = getRoutesForPermissionCode(pageName, pageName);
      if (routes.length === 0) return <span>{pageName}</span>;
      const tooltipHtml = routes
        .map(r => `${r.name} <span class="text-muted">(${r.path})</span>`)
        .join('<br/>');
      return (
        <span
          data-tooltip-id="my-tooltip"
          data-tooltip-html={tooltipHtml}
          style={{ textDecoration: 'underline dotted', cursor: 'help' }}
        >
          {pageName}
        </span>
      );
    }
  },
  {
    accessor: 'viewPermission',
    Header: 'View',
    Cell: rowData => {
      const { viewPermission } = rowData.row.original;
      return (
        <input
          type="checkbox"
          id="myCheckbox"
          name="myCheckbox"
          checked={viewPermission}
          readOnly
        />
      );
    }
  },
  {
    accessor: 'createPermission',
    Header: 'Create',
    Cell: rowData => {
      const { createPermission } = rowData.row.original;
      return (
        <input
          type="checkbox"
          id="myCheckbox"
          name="myCheckbox"
          checked={createPermission}
          readOnly
        />
      );
    }
  },
  {
    accessor: 'updatePermission',
    Header: 'Update',
    Cell: rowData => {
      const { updatePermission } = rowData.row.original;
      return (
        <input
          type="checkbox"
          id="myCheckbox"
          name="myCheckbox"
          checked={updatePermission}
          readOnly
        />
      );
    }
  },
  {
    accessor: 'deletePermission',
    Header: 'Delete',
    Cell: rowData => {
      const { deletePermission } = rowData.row.original;
      return (
        <input
          type="checkbox"
          id="myCheckbox"
          name="myCheckbox"
          checked={deletePermission}
          readOnly
        />
      );
    }
  },
  {
    accessor: 'action',
    Header: 'Action',
    Cell: () => <span className="text-primary">Edit</span>
  }
];

const UserPermissionTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  onPageSizeChange,
  handleClickRow
}) => {
  return (
    <PartialTable
      data={data}
      columns={columns}
      paging={paging}
      total={total}
      nextPage={nextPage}
      previousPage={previousPage}
      gotoPage={gotoPage}
      onPageSizeChange={onPageSizeChange}
      textAlign='left'
      handleClickRow={handleClickRow}
    />
  );
};

UserPermissionTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleClickRow: PropTypes.func
};

export default UserPermissionTable;
